'use client';

import { useEffect, useRef } from 'react';
import { staggerIn } from '@/utils/gsap';

export function useStaggerIn(opts = {}) {
  const ref = useRef(null);
  useEffect(() => {
    const els = ref.current?.querySelectorAll(':scope > *');
    const t = staggerIn(els, ref.current, opts);
    return () => t?.kill();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return ref;
}
